import { render, staticRenderFns } from "./DargainDetails.vue?vue&type=template&id=0431832b"
import script from "./DargainDetails.vue?vue&type=script&lang=js"
export * from "./DargainDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports